import template from './name-selector.html';
import { actions, selectors } from '../../../../state';
import { property, sortBy } from 'lodash-es';
import modalTemplate from './name-selector-modal.html';
import './name-selector.global.css';

const ADD_NEW_NAME = {
  fullName: 'Add New Name',
};

class NameSelectorController {
  constructor($element, $scope, $compile, updStore) {
    'ngInject';
    Object.assign(this, { $element, $scope, $compile, updStore });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
    this.modal = this.$compile(modalTemplate)(this.$scope)[0];

    if (!this.nameId) {
      this.handleNameIdChange(this.names[0].id);
    }
  }

  $onDestroy() {
    this.modal.close();
    this.modal.remove();
    this.disconnect();
  }

  trackEvent(event) {
    this.updStore.dispatch(
      actions.analytics.track(event, {
        // Subtracting 1 to account for the `Add New Name` option
        'Number of Names': this.names.length - 1,
        'Current Page': this.currentPageName,
      })
    );
  }

  get required() {
    return !!this.$element.attr('required');
  }

  onNameSelected(nameId) {
    if (nameId) {
      this.handleNameIdChange(nameId);
    } else {
      this.openModal();
      this.trackEvent('Opened Add A New Name Modal');
    }
  }

  handleNameIdChange(nameId) {
    this.previousId = nameId;
    this.change({ $value: nameId });
  }

  openModal() {
    document.body.appendChild(this.modal);
    this.modal.showModal();
  }

  closeModal(newNameId) {
    this.onNameSelected(newNameId);
    this.trackEvent('Added A New Name', { 'Name Id': newNameId });
    this.modal.close();
    this.modal.remove();
  }

  dismissModal() {
    this.nameId = this.previousId;
    this.trackEvent('Dismissed Add A New Name Modal');
    this.modal.close();
  }
}

export const NameSelectorComponent = {
  template,
  controller: NameSelectorController,
  bindings: {
    nameId: '<ngModel',
    change: '&',
  },
};

function mapStateToThis(state) {
  const { current, router } = selectors;

  const names = current.names(state).map(name => ({
    id: name.id(state),
    fullName: name.fullName(state),
    createdAt: name.createdAt(state),
  }));

  return {
    names: sortNewestToOldest(names).concat(ADD_NEW_NAME),
    currentPageName:
      router.currentAnalyticsPage(state) || router.currentName(state),
  };
}

function sortNewestToOldest(items) {
  return sortBy(items, property('createdAt')).reverse();
}
